module.exports = __webpack_public_path__ + "img/wyfzc1.fac8657a.png";